<template>
  <div
    :class="customClass"
    :style="{
      maskImage: `url(${iconSrc})`,
      WebkitMaskImage: `url(${iconSrc})`,
      maskSize: 'cover',
      WebkitMaskSize: 'cover'
    }"
  ></div>
</template>

<script setup>
/* global defineProps */
import { computed } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  customClass: {
    type: String,
    default: 'bg-white w-8 h-8'
  }
});

const iconSrc = computed(() => {
  try {
    const iconModule = require(`@/assets/img/${props.name}.svg`);
    
    // 객체 형태(Module)로 반환되면 .default를 꺼내 쓰고,
    // 만약 설정이 바뀌어 문자열로 바로 나오면 그대로 쓰도록 처리합니다.
    return iconModule.default || iconModule;
    
  } catch (error) {
    console.error(`아이콘을 찾을 수 없습니다: ${props.name}.svg`);
    return ''; 
  }
});
console.log('iconSrc', iconSrc.value);  
</script>
